module.exports = __webpack_public_path__ + "img/tile-effects_en.1ee948a.jpg";